import axios from '@/plugins/axios'
import { Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    whitelist: [],
    blocklist: [],
    pendingList: [],
    disabledList: [],
    selectedRequest: {},
    selectedDisabled: {},
    order_column: 'created_at',
    order_type: 'desc',
    page: 1,
    page_size: 100,
    dialog: false,
    dialog_insert: false,
    dialog_edit: false,
    dialog_review: false,
    dialog_disabled: false,
    dialog_block: false,
    filter: {},
    labels: [],
    selectedChannels: [],
    selectedAllChannels: false,
    channel: null
  },

  mutations: {
    setWhitelist(state, payload) {
      state.whitelist = payload
    },
    setBlocklist(state, payload) {
      state.blocklist = payload
    },
    setPendingList(state, payload) {
      state.pendingList = payload
    },
    setDisabledList(state, payload) {
      state.disabledList = payload
    },
    setSelectedRequest(state, payload) {
      state.selectedRequest = payload
    },
    setSelectedDisabled(state, payload) {
      state.selectedDisabled = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setDialogInsert(state, payload) {
      state.dialog_insert = payload
    },
    setDialogEdit(state, payload) {
      state.dialog_edit = payload
    },
    setSelectedChannel(state, payload) {
      state.channel = payload
    },
    setDialogReview(state, payload) {
      state.dialog_review = payload
    },
    setDialogDisabled(state, payload) {
      state.dialog_disabled = payload
    },
    setDialogBlock(state, payload) {
      state.dialog_block = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setLabels(state, labels) {
      state.labels = labels
    },
    setSelectedChannels(state, channels) {
      state.selectedChannels = channels
    },
    setSelectedAllChannels(state, bool) {
      state.selectedAllChannels = bool
    }
  },

  actions: {
    readWhitelist({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/whitelist', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setWhitelist', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readBlockList({ commit, state })
    {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/blocklist', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setBlocklist', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    insert({ commit, dispatch }, {channelId, labelIds}) {
      axios.admin
        .post('cms/youtube/whitelist', {
          channelId: channelId,
          labelIds: labelIds,
        })
        .then(() => {
          commit('setDialog', false)
          dispatch('readWhitelist')
        })
        .catch(err => {
          if (err.response.data && err.response.data.response.message) {
            Message({
              type: 'error',
              message: err.response.data.response.message
            })
            commit('setDialog', false)
          }
        })
    },
    edit({ commit, dispatch }, { id, channelId, labelIds }) {
      axios.admin
          .put(`cms/youtube/whitelist/${channelId}`, {
            channelId: channelId,
            labelIds: labelIds,
          })
          .then(() => {
            commit('setDialog', false)
            dispatch('readWhitelist')
          })
          .catch(err => {
            if (err.response.data && err.response.data.response.message) {
              Message({
                type: 'error',
                message: err.response.data.response.message
              })
              commit('setDialog', false)
            }
          })
    },
    blockInsert({ commit, dispatch }, channelId) {
      axios.admin
        .post('cms/youtube/blocklist', {
          channelId: channelId
        })
        .then(() => {
          commit('setDialogBlock', false)
          dispatch('readBlockList')
          dispatch('readWhitelist')
        })
        .catch(err => {
          if (err.response.data && err.response.data.response.message) {
            Message({
              type: 'error',
              message: err.response.data.response.message
            })
            commit('setDialogBlock', false)
          }
        })
    },
    destroy({ dispatch }, ids) {
      axios.admin.post('cms/youtube/whitelist/delete', { channels: ids })
          .then(() => {
        dispatch('readWhitelist')
      })
    },
    destroyBlocklistEntry({ dispatch }, id) {
      axios.admin.put('cms/youtube/blocklist/delete/' + id).then(() => {
        dispatch('readWhitelist')
        dispatch('readBlockList')
      })
    },
    readPendingList({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/whitelist/pending', {
            params: {
              page: state.page,
              page_size: state.page_size,
              order_column: state.order_column,
              order_type: state.order_type,
              ...state.filter
            }
          })
          .then(r => {
            commit('setPendingList', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    readDisabledList({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/whitelist/disabled', {
            params: {
              page: state.page,
              page_size: state.page_size,
              ...state.filter
            }
          })
          .then(r => {
            commit('setDisabledList', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    rejectDelete({ commit, dispatch }, payload) {
      commit('setLoading', true)
      const { id, reason } = payload
      axios.admin
          .put('cms/youtube/whitelist/reject-delete/'+id, {reason: reason})
          .then(r => {
            dispatch('readPendingList')
            dispatch('readWhitelist')
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    rejectInsert({ commit, dispatch }, payload) {
      commit('setLoading', true)
      const { ids, reason } = payload
      axios.admin
          .post('cms/youtube/whitelist/reject-insert', {
            reason: reason, channels: ids
          })
          .then(r => {
            dispatch('readPendingList')
            dispatch('readDisabledList')
            dispatch('readWhitelist')
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    approveDelete({ commit, dispatch }, id) {
      commit('setLoading', true)
      axios.admin
          .put('cms/youtube/whitelist/approve-delete/'+id, {})
          .then(r => {
            dispatch('readPendingList')
            dispatch('readDisabledList')
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    approveInsert({ commit, dispatch }, ids) {
      commit('setLoading', true)
      axios.admin
          .post('cms/youtube/whitelist/approve-insert', { channels: ids })
          .then(r => {
            dispatch('readPendingList')
            dispatch('readWhitelist')
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

    getLabels({ commit }) {
      axios.admin
        .get('cms/youtube/whitelist/labels')
        .then(r => {
          commit('setLabels', r.data.data)
        })
        .catch(err => {
          console.error('Error fetching labels:', err)
          Message({
            type: 'error',
            message: 'Failed to fetch labels'
          })
        })
    },
   }
}
